import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Home from "../Components/Home";
import About from "../Components/About";
import Services from "../Components/Services";
import Coures from "../Components/Courses";
import Contact from "../Components/Contact";
import Blogs from "../Components/Blogs";
import Details from "../Components/Details";
import Help from "../Components/Help";
import Portfolio from "../Components/Portfolio";
import PrivacyPolicy from "../Components/PrivacyPolicy";
import Products from "../Components/products/Products";
import ProductDetails from "../Components/products/ProductDetails";


const Navigation = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/services" element={<Services />} />
        <Route path="/portfolio" element={<Portfolio />} />
        <Route path="/courses" element={<Coures />} />
        <Route path="/products" element={<Products />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/blogs" element={<Blogs />} />
        <Route path="/details" element={<Details />} />
        <Route path="/help" element={<Help />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/product-details/:slug" element={<ProductDetails />} />
      </Routes>
    </BrowserRouter>
  );
};

export default Navigation;
